import { createUseStyles } from "react-jss";
import bannerBg from "assets/images/bannerBg.png";
export const useStyles = createUseStyles({
  billingSection: {
    "& .billingDetailsSection": {
      position: "relative",

      "& .ant-row *": {
        fontFamily: `'inter', serif !important`,
      },
      padding: "50px 0 100px",
      "& .billingForm": {
        "&>p": {
          marginBottom: "40px",
        },
        "& .exFields": {
          marginBottom: "15px",
          "& .formLabelCommon": {
            fontSize: "12px",
            marginBottom: "5px",
            color: "var(--blackOpacity75)",
            fontWeight: "500",
            display: "none",
            "& .text-danger": {
              color: "var(--danger)",
              fontWeight: "bold",
            },
          },
          "& input": {
            border: "none",
            borderRadius: "unset",
            borderBottom: "1px solid var(--blackOpacity10)",
            color: "var(--black)",
            paddingLeft: "unset",
            fontWeight: "500",
            "&::placeholder": {
              fontSize: "14px",
              fontWeight: "500",
            },
            "&:focus": {
              borderBottom: "1px solid var(--black)",
            },
          },
        },
        "& .formSmSection": {
          "& fieldset": {
            margin: "40px 0",
            borderColor: "var(--blackOpacity10)",
            padding: "25px",
            borderRadius: "10px",
            borderWidth: "0px",
            boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
            "& legend": {
              backgroundColor: "var(--sPrimary)",
              padding: "8px 12px",
              borderRadius: "5px",
            },
          },
        },
        "& .checkBox": {
          marginBottom: "50px",
          "& .ant-checkbox .ant-checkbox-inner": {
            backgroundColor: "transparent",
            borderColor: "var(--black)",
            "&:after": {
              borderColor: "var(--black)",
            },
          },
        },
      },
      "& .billingSummary": {
        position: "sticky",
        top: "20px",
        borderRadius: "10px",
        marginLeft: "20px",
        backgroundColor: "var(--sPrimary)",
        borderBottom: "5px solid var(--black)",
        "& .bSumHeader": {
          padding: "20px",
          borderBottom: "1px solid var(--blackOpacity10)",
          "& p": {
            color: "var(--black)",
          },
        },
        "& .bSumBody": {
          "& .bSumProductList": {
            padding: "10px 20px",
            "&:first-child": {
              marginTop: "10px",
            },
            "& .sSmText": {
              fontFamily: '"Frankfurter Std Regular", sans-serif!important',
              marginTop: "10px",
            },
          },
          "&>p": {
            padding: "10px",
            lineHeight: "18px",
            color: "var(--blackOpacity75)",
          },
          "& .bSumTotal": {
            marginTop: "20px",
            padding: "15px 20px",
            backgroundColor: "var(--white)",
            borderTop: "1px solid var(--blackOpacity10)",
            borderBottom: "1px solid var(--blackOpacity10)",
            boxShadow:"rgba(0, 0, 0, 0.2) 0px 3px 12px",
          },
        },
        "& .bSumFooter": {
          marginTop: "20px",
          padding: "20px",
        },
      },
    },
  },
});
